import Vue from 'vue';
import PreviewComponent from './preview.vue';

let instance;
// preview 是否存在的标记位
let installed = false;

const PreviewConstructor = Vue.extend(PreviewComponent);

const initInstance = () => {
    instance = new PreviewConstructor({
        el: document.createElement('div'),
    });
    document.body.appendChild(instance.$el);
};

/**
 * @param { String[] } urls 需要预览的图片链接列表
 * @param { String | Number } current 当前显示图片的链接
 */
const PreviewImage = ({ urls = [], current = 0 }) => {
    // 如果没有实例化，则实例化
    if (!installed) {
        installed = true;
        initInstance();
    }
    instance.show = true;
    instance.urls = urls;
    instance.current = current;
};

export default {
    install(vue) {
        vue.prototype.$imagePreview = PreviewImage;
    },
};
